/*
 * @Author: gongchengcheng
 * @Date: 2021-03-30 09:55:02
 * @version: v1.0.0
 * @Descripttion: 路由文件
 * @LastEditors: gongchengcheng
 * @LastEditTime: 2021-03-31 09:36:42
 * @Auditor: 
 */
import { createBrowserHistory } from 'history';

export const __Sorter__ = '__Sorter__';

export default createBrowserHistory();
